module.exports = __webpack_public_path__ + "static/img/Japan.11a89ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flag/Japan.png
// module id = GFJJ
// module chunks = 1